// src/packages/care/prediction/adapters/personalizedCycleModel.ts
//
// The primary/candidate model: the adaptive Bayesian cycle engine, wrapped as an adapter.
// Eligible once there are enough usable cycles to personalize.

import { getPeriodStartDates } from "../evidenceMapper";
import { getObservedCycleLengths } from "../cycleStats";
import { DATA_SUFFICIENCY } from "../knowledgeBase";
import {
  predictFertileWindow,
  MODEL_ID,
  MODEL_VERSION,
} from "../bayesianCycleModel";
import type { FertileWindowModel } from "./types";

export const personalizedCycleModel: FertileWindowModel = {
  id: MODEL_ID,
  version: MODEL_VERSION,
  isEligible(evidence) {
    const cycles = getObservedCycleLengths(getPeriodStartDates(evidence));
    return cycles.length >= DATA_SUFFICIENCY.minCyclesForPersonalized;
  },
  predict: (evidence, today) => predictFertileWindow(evidence, today),
};
